import { render, staticRenderFns } from "./imageDialogComponent.vue?vue&type=template&id=7487f753"
import script from "./imageDialogComponent.vue?vue&type=script&lang=js"
export * from "./imageDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports